import { message } from "antd";
import axiosInstance from "../axiosInstance";
import { PAGE_SIZE } from "../constants";

import {
	CREATE_CATEGORY_REQUEST,
	CREATE_CATEGORY_SUCCESS,
	CREATE_CATEGORY_FAIL,
	RESET_CATEGORIES,
	FETCH_CATEGORIES_REQUEST,
	FETCH_CATEGORIES_SUCCESS,
	FETCH_CATEGORIES_FAIL,
	UPDATE_CATEGORY_REQUEST,
	UPDATE_CATEGORY_SUCCESS,
	UPDATE_CATEGORY_FAIL,
	DELETE_CATEGORY_REQUEST,
	DELETE_CATEGORY_SUCCESS,
	DELETE_CATEGORY_FAIL,
	FETCH_CATEGORY_REQUEST,
	FETCH_CATEGORY_SUCCESS,
	FETCH_CATEGORY_FAIL,
} from "../constants/category";

const createCategory = (values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: CREATE_CATEGORY_REQUEST });
	try {
		const { data } = await axiosInstance.post(
			"/admin/survey-categories",
			values,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);
		message.success("Created.");
		dispatch(fetchCategories({ start: 0, count: PAGE_SIZE }));
		dispatch({
			type: CREATE_CATEGORY_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: CREATE_CATEGORY_FAIL, payload: errorMessage });
	}
};

const fetchCategories = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_CATEGORIES_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/survey-categories", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_CATEGORIES_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_CATEGORIES_FAIL, payload: errorMessage });
	}
};

const resetCategories = () => async (dispatch) => {
	dispatch({ type: RESET_CATEGORIES });
};

const updateCategory = (id, values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: UPDATE_CATEGORY_REQUEST });
	try {
		const { data } = await axiosInstance.patch(
			`/admin/survey-categories/${id}`,
			values,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);

		message.success("Updated.");
		dispatch({
			type: UPDATE_CATEGORY_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: UPDATE_CATEGORY_FAIL, payload: errorMessage });
	}
};

const deleteCategory = ({ id }) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: DELETE_CATEGORY_REQUEST });
	try {
		const { data } = await axiosInstance.delete(
			`/admin/survey-categories/${id}`,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);

		message.success("Deleted.");
		dispatch({
			type: DELETE_CATEGORY_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: DELETE_CATEGORY_FAIL, payload: errorMessage });
	}
};

const fetchCategory = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_CATEGORY_REQUEST });

	try {
		const { data } = await axiosInstance.get(`/admin/survey-categories/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({ type: FETCH_CATEGORY_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_CATEGORY_FAIL, payload: errorMessage });
	}
};

export {
	createCategory,
	resetCategories,
	fetchCategories,
	updateCategory,
	deleteCategory,
	fetchCategory,
};
